export default __webpack_public_path__ + "static/image-about_us-ea6fd49bc590479db8643968f159de18.jpg";